import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonImg, IonButton, IonList } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import { humanizePhone, sanitizePhone } from 'utils/phone';
import api_v2 from 'services/api_v2';
import schema from './schema';

function ChangePhoneForm() {
  const dispatch = useDispatch();
  const user = useSelector(AuthSelectors.selectUser);
  const token = useSelector(AuthSelectors.selectToken);
  const history = useHistory();

  const logout = () => dispatch(AuthActions.logout());

  const handleSubmit = async (values, actions) => {
    try {
      const data = { phone: sanitizePhone(values.phone), type: 'change' };
      await api_v2().requestSmsCode(data);

      dispatch(AuthActions.login(token, false));
      dispatch(
        AppActions.setToast('Verification code has been resent', 'success')
      );

      history.push('/verify-code');
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'Failed resending verification code',
          'danger'
        )
      );
    }

    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{ phone: humanizePhone(user.phone.replace('+1', '')) }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <div className="auth-logo">
                <IonImg src="/assets/vemospay-logo.png" />
              </div>
              <Field
                component={InputField}
                name="phone"
                type="tel"
                mask="999-999-9999"
                label="Phone number entered at sign-up:"
              />
              <div className="mb-2x mt-3x">
                <IonButton
                  color="secondary"
                  expand="block"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Resend Code
                </IonButton>
              </div>
              <IonButton
                color="light"
                expand="block"
                fill="solid"
                type="button"
                onClick={logout}
              >
                Log Out
              </IonButton>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ChangePhoneForm;
